export enum RecurringPaymentFrequency {
  DAY = 'day',
  WEEK = 'week',
  BIWEEKLY = 'biweekly',
  MONTH = 'month',
}

export enum RecurringPaymentStatus {
  PENDING_AUTHORISATION = 'pending_authorisation',
  ACTIVE = 'active',
  EXPIRED = 'expired',
  CANCELLED_BEFORE_AUTHORISATION = 'cancelled_before_authorisation',
  CANCELLED_BY_CUSTOMER = 'cancelled_by_customer',
  CANCELLED_BY_ADMIN = 'cancelled_by_admin',
  CANCELLED_COLLECTION_FAILED = 'cancelled_collection_failed',
  ENDED = 'ended',
}

export type RecurringPaymentResponse = {
  id: string;
  organisation_id: string;
  client_id: string;
  account_id: string;
  mandate_id: string;
  amount: string;
  currency: string;
  frequency: RecurringPaymentFrequency;
  collection_day: number | null;
  start_date: string | null;
  end_date: string | null;
  next_collection_date: string | null;
  status: RecurringPaymentStatus;
  status_reason: string | null;
  created_at: string;
  updated_at: string;
};

export type RecurringPaymentType = {
  id: string;
  organisationId: string;
  clientId: string;
  accountId: string;
  mandateId: string;
  amount: number | string;
  currency: string;
  frequency: RecurringPaymentFrequency;
  collectionDay?: number;
  startDate?: string;
  endDate?: string;
  nextCollectionDate?: string;
  status: RecurringPaymentStatus;
  statusReason?: string;
  createdAt: string;
  updatedAt: string;
};

/** Every other status is terminal, so the provider rejects a cancellation against it. */
export const cancellableRecurringPaymentStatuses: RecurringPaymentStatus[] = [
  RecurringPaymentStatus.PENDING_AUTHORISATION,
  RecurringPaymentStatus.ACTIVE,
];

export function isRecurringPaymentCancellable(status?: RecurringPaymentStatus): boolean {
  return !!status && cancellableRecurringPaymentStatuses.includes(status);
}

/**
 * A mandate decorated with what its row may offer, for the listing templates to branch on.
 * `actionEnabled` is finx-table's own row-level convention for suppressing the row menu.
 */
export type RecurringPaymentRow = RecurringPaymentType & {
  actionEnabled: boolean;
  cancelEnabled: boolean;
};

export function mapRecurringPaymentResponse(response: RecurringPaymentResponse): RecurringPaymentType {
  return {
    id: response.id,
    organisationId: response.organisation_id,
    clientId: response.client_id,
    accountId: response.account_id,
    mandateId: response.mandate_id,
    amount: response.amount,
    currency: response.currency,
    frequency: response.frequency,
    collectionDay: response.collection_day ?? undefined,
    startDate: response.start_date ?? undefined,
    endDate: response.end_date ?? undefined,
    nextCollectionDate: response.next_collection_date ?? undefined,
    status: response.status,
    statusReason: response.status_reason ?? undefined,
    createdAt: response.created_at,
    updatedAt: response.updated_at,
  };
}
